// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9b01343","453":"18a99d7c","732":"1f9901ee","977":"44ccc987"}[chunkId] + ".chunk.js";
};